import './assets/tailwind.css'
import { createApp } from 'vue'
import './style.css'
import RouterRoot from './RouterRoot.vue'
import router from './router'

createApp(RouterRoot).use(router).mount('#app')
